import React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import Message from 'antd/lib/message';

import {TypeKeys} from '@common/react/store/VideoChat';

import {request} from '@app/components/Api';

interface SystemCallButtonProps {
	roomId: string;
	roomName: string;
	roomCreateActor: string;
	chatId?: number;
	button?: (onClick: React.MouseEventHandler, isDisabled: boolean) => JSX.Element;
	avatar?: string;
	notifyUserIds?: number[];
}

const SystemCallButton: React.FC<SystemCallButtonProps> = ({button, roomCreateActor, roomId, roomName, chatId, avatar, notifyUserIds}) => {
	const dispatch = useDispatch();
	const videoChatState = useSelector((state: any) => state.videoChat);
	
	const handleClick: React.MouseEventHandler = (e) => {
		e.preventDefault();
		
		const handleSuccess = (res) => {
			dispatch({
				type: TypeKeys.UPDATE, 
				data: {
					token: res.token,
					roomIdentifier: res.roomIdentifier,
					roomName: roomName,
					avatar: avatar,
					preventCameraStart: true,
					hasError: false
				}
			});
		};
		
		request<{token: string, roomIdentifier: string}>(roomCreateActor, {roomName: roomId, chatId, notifyUserIds})
			.then(handleSuccess)
			.catch((e) => {
				Message.error(e);
				dispatch({type: TypeKeys.UPDATE, data: {hasError: true}});
			});
		
		dispatch({
			type: TypeKeys.UPDATE,
			data: {
				visibility: true,
				isChatting: true,
				roomName: roomName,
				avatar: avatar,
				preventCameraStart: true,
				hasError: false
			}});
	};
	
	return (
		button ?
			button(handleClick, videoChatState.isChatting) :
			<button className="btn btn-primary">
				<i className="fa fa-phone-square" />
			</button>
	);
};

export default SystemCallButton;